import { Component, Input, OnInit } from '@angular/core';

export class EaNewSmall {
  index: number;
  title: string;
  category: string;
  image: string;
  link: string;
  description: string;
  lead: string;

  constructor(
    index: number,
    title: string,
    category: string,
    description: string,
    lead: string,
    image: string,
    link: string,
  ) {
    this.index = index;
    this.title = title;
    this.category = category;
    this.lead = lead;
    this.description = description;
    this.image = image;
    this.link = link;
  }
}

@Component({
    selector: 'ea-new-small',
    templateUrl: './ea-new-small.component.html',
    styleUrls: [
        '../ea-new/ea-new.component.scss',
        './ea-new-small.component.scss',
    ],
    standalone: false
})
export class EaNewSmallComponent implements OnInit {
  @Input() index: number;
  @Input() title: string;
  @Input() category: string;
  @Input() description: string;
  @Input() lead: string;
  @Input() image: string;
  @Input() link: string;
  @Input() loading: boolean = false;

  @Input() set eaNewSmall(eaNewSmall: EaNewSmall) {
    this.index = eaNewSmall.index;
    this.title = eaNewSmall.title;
    this.category = eaNewSmall.category;
    this.description = eaNewSmall.description;
    this.lead = eaNewSmall.lead;
    this.image = eaNewSmall.image;
    this.link = eaNewSmall.link;
  }

  constructor() {}

  ngOnInit() {}
}
